import { Guid } from 'guid-typescript'
import { RetornoDefault } from 'models/Geral/RetornoDefault'
import api from 'services/api.service'

const urlBaseTerrenos = '/terreno'

export const buscarTerrenoPorId = async (idTerreno: Guid): Promise<RetornoDefault> => {
  const response = await api.get(`${urlBaseTerrenos}/obter/${idTerreno}`)
  return response.data as RetornoDefault
}
